<ng-container *ngIf="data | async as items; else loadingTmpl">
  <ng-container *ngFor="let item of items">
    <ng-container *ngIf="form.controls[item.key]">
      <div class="c-form-field c-form-field--d" [ngSwitch]="item.value.type">
        <ng-container *ngSwitchDefault>
          <p500-ui-text-field
            [hint]="item.value.tooltip"
            [formControl]="form.controls[item.key]"
            [label]="item.value.label"
            [placeholder]="item.value.placeholder"
          >
          </p500-ui-text-field>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #loadingTmpl>
  <p500-ui-cube-preloader *ngIf="isLoading; else emptyTmpl"></p500-ui-cube-preloader>
  <ng-template #emptyTmpl>
    <gtd-empty icon="box" [noBorder]="true" i18n-desc="@@settings.wasnt_found" desc="Settings wasn't found." height="100"> </gtd-empty>
  </ng-template>
</ng-template>
